<template>
  <div
    class="productBadges"
    :class="{
      'productBadges--inline': inline,
    }"
  >
    <template v-for="(badge, index) in badges">
      <div v-if="badge.iconType == null" :key="index" class="productBadges__item">
        <component
          :is="badge.slug ? 'nuxt-link' : 'span'"
          :to="localePath({ name: `${badge.type}-slug`, params: { slug: badge.slug } })"
          class="productBadges__itemInner productBadges__itemInner--promotion"
          :style="`background-color: ${badge.color}`"
        >
          {{ badge.name }}
        </component>
      </div>
    </template>
    <template v-for="(badge, index) in badges">
      <div
        v-if="badge.iconType != null"
        :key="index"
        class="productBadges__item productBadges__item--icon"
      >
        <component
          :is="'span'"
          class="productBadges__itemInner productBadges__itemInner--promotion productBadges__itemInner--icon"
        >
          <span :class="['productBadges__icon', `icon-${badge.iconType}`]"></span>

          <svg
            width="69"
            height="48"
            viewBox="0 0 69 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 4.8C0 2.14903 2.14903 0 4.8 0H58.6523C60.8548 0 62.7748 1.49903 63.309 3.63583L68.109 22.8358C68.3 23.6002 68.3 24.3998 68.109 25.1642L63.309 44.3642C62.7748 46.501 60.8548 48 58.6523 48H4.8C2.14903 48 0 45.851 0 43.2V4.8Z"
              :fill="badge.color"
            />
          </svg>
        </component>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProductBadges',
  props: {
    badges: {
      type: Array,
      default: () => [],
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.productBadges {
  $root: &;

  &__item {
    margin-bottom: 0.6rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__itemInner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 25px;
    padding-left: 1.3rem;
    padding-right: 1.3rem;
    border-radius: 50px;
    text-transform: uppercase;
    color: $cWhite;
    font-size: 1rem;
    line-height: 1.3rem;
    letter-spacing: 0.05em;
    font-weight: 700;

    &--icon {
      position: relative;
      height: auto;
      padding: 0;
    }
  }

  &--inline {
    display: flex;
    flex-wrap: wrap;
    margin-left: -3px;
    margin-right: -3px;

    #{$root}__item {
      padding-left: 3px;
      padding-right: 3px;

      &--icon {
        margin-top: 4px;
        flex: 0 0 100%;
      }
    }
  }

  &__icon {
    font-size: 3rem;
    position: absolute;
    top: 50%;
    left: 25%;
    transform: translateY(-50%);
  }
}
</style>
